export default __webpack_public_path__ + "static/media/refresh.8598f35f.svg";